function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import PictureComponent from "components/core/picture/picture-component";
import { StyledReviewCardsReviewsComponentMobileComponent } from "./review-cards-reviews-mobile-component.scss";
import ReviewCardComponent from "../review-card-reviews-component/review-card-reviews-component";
export const ReviewCardsReviewsComponentMobileComponent = (props)=>{
    const { fullParagraph, marginAboveCards, cards, spaceFromParagraph, buttonTopMargin, titleSize, textSize } = props;
    const { topic, buttonConfig, topicBottomMargin } = fullParagraph, fullParagraphForMobile = _object_without_properties(fullParagraph, [
        "topic",
        "buttonConfig",
        "topicBottomMargin"
    ]);
    const fullParagraphAdvancedProps = {
        spaceFromParagraph,
        buttonTopMargin,
        titleSize,
        textSize,
        topic: {}
    };
    const itemRenderer = (card)=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "card-item",
            children: /*#__PURE__*/ _jsx(ReviewCardComponent, {
                reviewCardProps: card
            })
        });
    };
    const carouselProps = {
        items: cards,
        itemRenderer,
        defaultIndex: 0,
        infinite: false,
        slidesToShow: 1,
        dots: true,
        autoplaySpeed: 5000,
        centerPadding: "15%"
    };
    return /*#__PURE__*/ _jsxs(StyledReviewCardsReviewsComponentMobileComponent, {
        className: "review-cards-reviews-mobile-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "paragraph-and-topic",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "paragraph-wrapper",
                        children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, fullParagraphForMobile, fullParagraphAdvancedProps))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "topic-wrapper",
                        style: {
                            "--topic-margin": topicBottomMargin
                        },
                        children: /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, topic === null || topic === void 0 ? void 0 : topic.image))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "carousel-wrapper",
                style: {
                    "--margin-above-cards": marginAboveCards
                },
                children: /*#__PURE__*/ _jsx(Carousel, _object_spread({}, carouselProps))
            })
        ]
    });
};
